import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { DataRowComponent } from "../../_component/pagination-client-side/data-row.component";
import { DictionaryService } from "../../../dictionary/dictionary.service";
import { UserService } from "src/app/_services";

@Component({
  selector: "app-building-floor-view",
  templateUrl: "./building-floor-view.component.html",
  styleUrls: [
    "./../../../_styles/ion-grid-content-table.scss",
    "./building-floor-view.component.scss",
  ],
})
export class BuildingFloorViewComponent implements OnInit, DataRowComponent {
  constructor(
    public dictionaryService: DictionaryService,
    private userServ: UserService
  ) {}

  permissionEdit = false;
  ngOnInit() {
    this.permissionEdit = this.userServ.hasRoles(["building.floor.edit"]);
  }

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  delete($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.actionRequest.emit({
      type: "remove",
      id: this.row.id,
    });
  }

  edit() {
    this.actionRequest.emit({
      type: "edit",
      id: this.row.id,
    });
  }
}
